import React, { useEffect, useRef, useState } from "react";
import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { clear } from "../../Services/Storage";
import { AddressPicker } from "./AddressPicker";
import { baseUrl } from "../../Services/Axios";
import { ReferralModal } from "../../Common/Components/ReferralModal";
import { getReferralBaseUrl } from "../../Services/Storage";

// const NavDropdownMenu = ({ name }) => {
//   const [showDrp, setShowDrp] = useState(false);
//   const [showSubDrp, setSubShowDrp] = useState(false);
//   const [showReferral, setShowReferral] = React.useState(false);
//   const [showAddress, setShowAddress] = React.useState(false);
//   const customer = useSelector((x) => x.Customer);
//   // console.log(`customer from navdropdown menu`, customer?.referral_code);
  
//   const dropdownRef = useRef(null);
//   const subDropdownRef = useRef(null);
//   const toggleDropdownRef = useRef(null);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const Logout = () => {
//     dispatch({ type: "setToken", payload: null });
//     dispatch({ type: "setOrderType", payload: null });
//     dispatch({ type: "setBookingType", payload: null });
//     dispatch({ type: "setOrderTypeId", payload: null });

//     dispatch({ type: "setService", payload: null });
//     dispatch({ type: "setCategory", payload: null });
//     dispatch({ type: "setCart", payload: [] });
//     dispatch({ type: "setLoggedIn", payload: false });
//     dispatch({ type: "setZone", payload: null });
//     dispatch({ type: "setCustomer", payload: null });
//     dispatch({ type: "setAddress", payload: null });
//     dispatch({ type: "setAddresses", payload: null });
//     dispatch({ type: "setOngoingOrders", payload: null });
//     dispatch({ type: "setNote", payload: null });
//     dispatch({ type: "setPickupDate", payload: null });
//     dispatch({ type: "setDeliveryDate", payload: null });
//     dispatch({ type: "setCoupon", payload: null });
//     dispatch({ type: "setRole", payload: null });
//     dispatch({ type: "setAdmin", payload: null });
//     clear();
//     setSubShowDrp(!showSubDrp);
//     setShowDrp(!showDrp);
//     navigate("/app", { replace: true });
//   };

//   const handleClickOutside = (event) => {
//     if (
//       dropdownRef.current &&
//       !dropdownRef.current.contains(event.target) &&
//       subDropdownRef.current &&
//       !subDropdownRef.current.contains(event.target) &&
//       toggleDropdownRef.current &&
//       !toggleDropdownRef.current.contains(event.target)
//     ) {
//       setShowDrp(false);
//       setSubShowDrp(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleClickReferral = () => {
//     setShowReferral(true);
//     setShowDrp(false);
//   }

//   const fallbackCopy = (text) => {
//   const textarea = document.createElement("textarea");
//   textarea.value = text;
//   document.body.appendChild(textarea);
//   textarea.select();
//   document.execCommand("copy");
//   document.body.removeChild(textarea);
//   };


//   const handleCopyReferral = async () => {
//     const referral_code = customer?.referral_code || "";
//     const baseURL = getReferralBaseUrl();
//     // console.log(`baseURL`,baseURL);
//     const link = `${baseURL}/ordernow/app/sign-up?ref=${referral_code}`
//     // console.log(`customer from navdropdown menu`, customer?.referral_code);
//     try {
//       await navigator.clipboard.writeText(link);
//       alert("Referral link copied!");
//     } catch {
//       fallbackCopy(link);
//     }
//   };

//   return (
//     <>
//       <Nav.Link
//         className="pb-md-0 d-flex align-items-center fw-normal nav-drop"
//         as={"div"}
//       >
//         <span
//           className="nav-drop-toggle"
//           onClick={() => setShowDrp(!showDrp)}
//           ref={toggleDropdownRef}
//         >
//           <img
//             src={process.env.PUBLIC_URL + "/assets/svgs/icons/user-icon.svg"}
//             alt=""
//             style={{ marginRight: "6px" }}
//           />
//           Welcome, {name.split(" ")[0]}
//         </span>
//         <div
//           ref={dropdownRef}
//           className={`nav-drop-menu ${showDrp ? "show-drop" : ""}`}
//         >
//           <div className="nav-drop-heading">{name}</div>
//           <hr style={{ margin: "8px 0px 4px 0px" }} />
//           <Link
//             to="/app/ongoing-orders"
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>Ongoing Orders</span>
//             </div>
//           </Link>
//           <Link
//             to="/app/scheduled-orders"
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>Scheduled Orders</span>
//             </div>
//           </Link>
//           <Link
//             to="/app/outstanding-orders"
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>DNPL Orders</span>
//             </div>
//           </Link>
//           <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/orders-history"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>Orders History</span>
//             </div>
//           </Link>
//           <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/wallet"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>Wallet</span>
//             </div>
//           </Link>
//           <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/notifications"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/notification.svg"} alt="" />
//               <span>Notification</span>
//             </div>
//           </Link>
//           <div className="nav-drop-item">
//             <div className="nav-drop-hover"
//               onClick={() => {
//                 handleClickReferral();
//                 console.log("Referral modal clicked");
//               }}>
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>Refer & Get 10% Discount</span>
//             </div>
//           </div>
//           <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/myreferrals"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>My Referrals</span>
//             </div>
//           </Link>
//           <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/notes-management"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon-1.svg"} alt="" />
//               <span>My Order Notes</span>
//             </div>
//           </Link>
//           {/* <Link
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             to="/app/notifications-settings"
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/notification.svg"} alt="" />
//               <span>Notification Settings</span>
//             </div>
//           </Link> */}
//           <hr style={{ margin: "4px 0px" }} />
//           <div
//             className="nav-drop-item"
//             onClick={() => setSubShowDrp(!showSubDrp)}
//           >
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/user-icon.svg"} alt="" />
//               <span>My Profile</span>
//             </div>
//             <div
//               ref={subDropdownRef}
//               className={`nav-drop-menu ${showSubDrp ? "show-drop" : ""}`}
//             >
//               <Link
//                 to="/app/profile"
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//               >
//                 <div className="nav-drop-hover">
//                   <span>Profile</span>
//                 </div>
//               </Link>
//               <Link
//                 to="/app/change-password"
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//               >
//                 <div className="nav-drop-hover">
//                   <span>Change Password</span>
//                 </div>
//               </Link>
//               <div
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(!showSubDrp);
//                   setShowDrp(!showDrp);
//                   setShowAddress(true);
//                 }}
//               >
//                 <div className="nav-drop-hover">
//                   <span>Addresses</span>
//                 </div>
//               </div>
//               <a
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//                 href={`${baseUrl}/faq`}
//                 target="_blank"
//               >
//                 <div className="nav-drop-hover">
//                   <span>Help & Support</span>
//                 </div>
//               </a>
//               <Link
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//                 to="/app/service-review"
//               >
//                 <div className="nav-drop-hover">
//                   <span>Service Review</span>
//                 </div>
//               </Link>
//               <a
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//                 href={`${baseUrl}/about-us`}
//                 target="_blank"
//               >
//                 <div className="nav-drop-hover">
//                   <span>About Jabchaho</span>
//                 </div>
//               </a>
//               <a
//                 className="nav-drop-item"
//                 onClick={() => {
//                   setSubShowDrp(false);
//                   setShowDrp(false);
//                 }}
//                 href={`${baseUrl}/privacy-policy`}
//                 target="_blank"
//               >
//                 <div className="nav-drop-hover">
//                   <span>Privacy Policy </span>
//                 </div>
//               </a>
//             </div>
//           </div>

//           <a
//             className="nav-drop-item"
//             onClick={() => {
//               setSubShowDrp(false);
//               setShowDrp(false);
//             }}
//             href={`${baseUrl}/contact-us`}
//             target="_blank"
//           >
//             <div className="nav-drop-hover">
//               {/* <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/notification.svg"} alt="" /> */}
//               <i
//                 className="fa-regular fa-envelope"
//                 style={{ marginRight: "11px", fontSize: "18px" }}
//               ></i>
//               <span>Contact Us</span>
//             </div>
//           </a>
//           <hr style={{ margin: "4px 0px" }} />
//           <div className="nav-drop-item mb-0" onClick={() => Logout()}>
//             <div className="nav-drop-hover">
//               <img src={process.env.PUBLIC_URL + "/assets/svgs/icons/logout.svg"} alt="" />
//               <span>Logout</span>
//             </div>
//           </div>
//         </div>
//       </Nav.Link>
//       <AddressPicker
//         show={showAddress}
//         closeButton={true}
//         onHide={() => setShowAddress(false)}
//         title="Below are your addresses!"
//         editOnSelect={true}
//       />
//       <ReferralModal
//         show={showReferral}
//         onNo={() => setShowReferral(false)}
//         onYes={() => {
//           handleCopyReferral(); // API call or link logic inside this function
//           setShowReferral(false); // close modal
//         }}
//         text="Copy your referral code and share it with your friends to get a 10% discount on your next order!"
//       />
//     </>
//   );
// };

// export default NavDropdownMenu;


const NavDropdownMenu = ({ name }) => {
  const [showDrp, setShowDrp] = useState(false);
  const [showSubDrp, setSubShowDrp] = useState(false);
  const [showReferral, setShowReferral] = React.useState(false);
  const [showAddress, setShowAddress] = React.useState(false);
  const [view, setView] = useState("main"); // "main" | "profile"
  const customer = useSelector((x) => x.Customer);

  const dropdownRef = useRef(null);
  const toggleDropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Logout = () => {
    dispatch({ type: "setToken", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setLoggedIn", payload: false });
    dispatch({ type: "setZone", payload: null });
    dispatch({ type: "setCustomer", payload: null });
    dispatch({ type: "setAddress", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setOngoingOrders", payload: null });
    dispatch({ type: "setNote", payload: null });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setCoupon", payload: null });
    dispatch({ type: "setRole", payload: null });
    dispatch({ type: "setAdmin", payload: null });
    clear();
    setSubShowDrp(false);
    setShowDrp(false);
    setView("main");
    navigate("/app", { replace: true });
  };

  const handleClickOutside = (event) => {
    if (
      !dropdownRef.current?.contains(event.target) &&
      !toggleDropdownRef.current?.contains(event.target)
    ) {
      setShowDrp(false);
      setSubShowDrp(false);
      setView("main");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickReferral = () => {
    setShowReferral(true);
    setShowDrp(false);
    setView("main");
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  const handleCopyReferral = async () => {
    const referral_code = customer?.referral_code || "";
    const baseURL = getReferralBaseUrl();
    const link = `${baseURL}/ordernow/app/sign-up?ref=${referral_code}`;
    try {
      await navigator.clipboard.writeText(link);
      alert("Referral link copied!");
    } catch {
      fallbackCopy(link);
    }
  };

  const close = () => {
    setShowDrp(false);
    setSubShowDrp(false);
    setView("main");
  };

  // ── Grid MenuItem (2-col grid) ──
  const MenuItem = ({ to, href, icon, iconSrc, iconColor = "#6C63FF", iconBg = "#F0EFFF", label, onClick, red }) => {
    const content = (
      <div
        style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", border: "1px solid #EFEFEF", borderRadius: "12px",
          padding: "7px 5px", gap: "4px", cursor: "pointer",
          transition: "background 0.2s ease", background: "#fff"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#F9F9F9"}
        onMouseLeave={e => e.currentTarget.style.background = "#fff"}
      >
        <span style={{ width: "27px", height: "27px", borderRadius: "9px", display: "inline-flex", alignItems: "center", justifyContent: "center", background: red ? "#FFF0F0" : iconBg }}>
          {iconSrc ? (
            <img src={process.env.PUBLIC_URL + iconSrc} alt="" aria-hidden="true" style={{ width: "16px", height: "16px", objectFit: "contain" }} />
          ) : (
            <i className={`fa-solid ${icon}`} style={{ fontSize: "15px", color: red ? "#E05252" : iconColor }}></i>
          )}
        </span>
        <span style={{ fontSize: "11px", lineHeight: "1.2", textAlign: "center", fontWeight: "500", color: red ? "#E53935" : "#111" }}>
          {label}
        </span>
      </div>
    );
    if (href) return <a href={href} target="_blank" rel="noreferrer" onClick={close} style={{ textDecoration: "none" }}>{content}</a>;
    if (to) return <Link to={to} onClick={close} style={{ textDecoration: "none" }}>{content}</Link>;
    return <div onClick={() => { if (onClick) onClick(); }}>{content}</div>;
  };

  // ── Profile sub-view row item ──
  const ProfileItem = ({ to, href, icon, iconSrc, iconColor = "#6C63FF", iconBg = "#F0EFFF", label, onClick }) => {
    const content = (
      <div
        style={{
          display: "flex", alignItems: "center", gap: "12px",
          padding: "9px 12px", borderRadius: "10px", cursor: "pointer",
          border: "1px solid #EFEFEF", background: "#fff",
          transition: "background 0.2s ease"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#F9F9F9"}
        onMouseLeave={e => e.currentTarget.style.background = "#fff"}
      >
        <span style={{ width: "25px", height: "25px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", background: iconBg }}>
          {iconSrc ? (
            <img src={process.env.PUBLIC_URL + iconSrc} alt="" aria-hidden="true" style={{ width: "15px", height: "15px", objectFit: "contain" }} />
          ) : (
            <i className={`fa-solid ${icon}`} style={{ fontSize: "13px", color: iconColor }}></i>
          )}
        </span>
        <span style={{ fontSize: "12px", fontWeight: "500", color: "#111" }}>{label}</span>
        <i className="fa-solid fa-chevron-right" style={{ fontSize: "11px", color: "#ccc", marginLeft: "auto" }}></i>
      </div>
    );
    if (href) return <a href={href} target="_blank" rel="noreferrer" onClick={close} style={{ textDecoration: "none", display: "block", marginBottom: "6px" }}>{content}</a>;
    if (to) return <Link to={to} onClick={close} style={{ textDecoration: "none", display: "block", marginBottom: "6px" }}>{content}</Link>;
    return <div onClick={() => { if (onClick) onClick(); }} style={{ marginBottom: "6px" }}>{content}</div>;
  };

  const SectionLabel = ({ label }) => (
    <p style={{ fontWeight: "700", fontSize: "12px", color: "#111", margin: "10px 0 4px" }}>{label}</p>
  );

  const Grid = ({ children }) => (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>{children}</div>
  );

  return (
    <>
      <Nav.Link className="pb-md-0 d-flex align-items-center fw-normal nav-drop consumer-nav-dropdown" as={"div"}>

        {/* ── Trigger Button ── */}
        <span
          className="nav-drop-toggle"
          ref={toggleDropdownRef}
          onClick={() => { setShowDrp(!showDrp); setView("main"); }}
          style={{
            display: "flex", alignItems: "center", gap: "8px",
            // background: "#fff", border: "1px solid #EFEFEF",
            // borderRadius: "50px", padding: "7px 14px", cursor: "pointer",
            // boxShadow: "0 1px 4px rgba(0,0,0,0.07)"
          }}
        >
          <i className="fa-regular fa-user" style={{ color: "#F5A623", fontSize: "16px" }}></i>
          <span style={{ fontSize: "14px", color: "#111" }}>Welcome, {name.split(" ")[0]}</span>
          <i className={`fa-solid fa-chevron-${showDrp ? "up" : "down"}`} style={{ fontSize: "11px", color: "#888" }}></i>
        </span>

        {/* ── Dropdown ── */}
        <div
          ref={dropdownRef}
          className={`nav-drop-menu ${showDrp ? "show-drop" : ""}`}
          style={{ width: "300px", zIndex: 1050, padding: "10px", maxHeight: "calc(100vh - 90px)", overflowY: "auto", overscrollBehavior: "contain", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", border: "1px solid #F0F0F0" }}
        >

          {/* ════ MAIN VIEW ════ */}
          {view === "main" && (
            <>
              {/* User Header */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "7px", borderBottom: "1px solid #F0F0F0" }}>
  <div style={{ background: "#FFF8EC", borderRadius: "50%", width: "30px", height: "30px", minWidth: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <i className="fa-regular fa-user" style={{ color: "#F5A623", fontSize: "13px" }}></i>
  </div>
  <p className="mb-0 fw-bold" style={{ fontSize: "13px", color: "#111" }}>{name}</p>
</div>

              {/* Orders */}
              <SectionLabel label="Orders" />
              <Grid>
                <MenuItem to="/app/ongoing-orders" iconSrc="/assets/svgs/icons/bag-icon-1.svg" iconBg="#FFF4DE" label="Ongoing Orders" />
                <MenuItem to="/app/scheduled-orders" iconSrc="/assets/svgs/icons/appointment.svg" iconBg="#EAF7FF" label="Scheduled Orders" />
                <MenuItem to="/app/outstanding-orders" iconSrc="/assets/svgs/icons/bag-icon-1.svg" iconBg="#FFF0E8" label="DNPL Orders" />
                <MenuItem to="/app/orders-history" icon="fa-clock-rotate-left" iconColor="#4D9B87" iconBg="#E9F8F3" label="Order History" />
              </Grid>

              {/* Rewards & Wallet */}
              <SectionLabel label="Rewards & Wallet" />
              <Grid>
                <MenuItem to="/app/wallet" icon="fa-wallet" iconColor="#6C63FF" iconBg="#F0EFFF" label="Wallet" />
                <MenuItem to="/app/notifications" iconSrc="/assets/svgs/icons/notification.svg" iconBg="#FFF4DE" label="Notifications" />
                <MenuItem icon="fa-tag" iconColor="#E98742" iconBg="#FFF1E7" label="Refer & Earn" onClick={handleClickReferral} />
                <MenuItem to="/app/myreferrals" icon="fa-user-group" iconColor="#D45D91" iconBg="#FDECF4" label="My Referrals" />
              </Grid>

              {/* Preferences */}
              <SectionLabel label="Preferences" />
              <Grid>
                <MenuItem icon="fa-house" iconColor="#4D9B87" iconBg="#E9F8F3" label="My Addresses" onClick={() => { setShowAddress(true); close(); }} />
                <MenuItem to="/app/notes-management" icon="fa-file-lines" iconColor="#5D8ED4" iconBg="#EAF2FF" label="Order Notes" />
              </Grid>

              {/* Account */}
              <SectionLabel label="Account" />
              <Grid>
                <MenuItem iconSrc="/assets/svgs/icons/user-icon.svg" iconBg="#F0EFFF" label="My Profile" onClick={() => setView("profile")} />
                <MenuItem href={`${baseUrl}/contact-us`} icon="fa-envelope" iconColor="#D45D91" iconBg="#FDECF4" label="Contact Us" />
                <MenuItem to="/app/change-password" icon="fa-shield-halved" iconColor="#5D8ED4" iconBg="#EAF2FF" label="Security" />
                <MenuItem iconSrc="/assets/svgs/icons/logout.svg" label="Log Out" onClick={Logout} red />
              </Grid>
            </>
          )}

          {/* ════ PROFILE SUB VIEW ════ */}
          {view === "profile" && (
            <>
              {/* Back Header */}
              <div
                onClick={() => setView("main")}
                style={{ display: "flex", alignItems: "center", gap: "9px", paddingBottom: "10px", borderBottom: "1px solid #F0F0F0", cursor: "pointer" }}
              >
                <i className="fa-solid fa-arrow-left" style={{ fontSize: "14px", color: "#555" }}></i>
                <span style={{ fontWeight: "700", fontSize: "15px", color: "#111" }}>My Profile</span>
              </div>

              <div style={{ marginTop: "9px" }}>
                <ProfileItem to="/app/profile" iconSrc="/assets/svgs/icons/user-icon.svg" label="Profile" />
                <ProfileItem to="/app/change-password" icon="fa-lock" iconColor="#5D8ED4" iconBg="#EAF2FF" label="Change Password" />
                <ProfileItem
                  icon="fa-location-dot"
                  iconColor="#4D9B87"
                  iconBg="#E9F8F3"
                  label="Addresses"
                  onClick={() => { setShowAddress(true); close(); }}
                />
                <ProfileItem href={`${baseUrl}/faq`} icon="fa-circle-question" iconColor="#E98742" iconBg="#FFF1E7" label="Help & Support" />
                <ProfileItem to="/app/service-review" icon="fa-star" iconColor="#E2A820" iconBg="#FFF7DD" label="Service Review" />
                <ProfileItem href={`${baseUrl}/about-us`} icon="fa-circle-info" iconColor="#6C63FF" iconBg="#F0EFFF" label="About Jabchaho" />
                <ProfileItem href={`${baseUrl}/privacy-policy`} icon="fa-shield-halved" iconColor="#5D8ED4" iconBg="#EAF2FF" label="Privacy Policy" />
              </div>
            </>
          )}

        </div>
      </Nav.Link>

      {/* ── Modals (unchanged) ── */}
      <AddressPicker
        show={showAddress}
        closeButton={true}
        onHide={() => setShowAddress(false)}
        title="Below are your addresses!"
        editOnSelect={true}
      />
      <ReferralModal
        show={showReferral}
        onNo={() => setShowReferral(false)}
        onYes={() => {
          handleCopyReferral();
          setShowReferral(false);
        }}
        text="Copy your referral code and share it with your friends to get a 10% discount on your next order!"
      />
    </>
  );
};

export default NavDropdownMenu;
